import { render, staticRenderFns } from "./DocumentsCompanyTable.vue?vue&type=template&id=98a58b16&scoped=true"
import script from "./DocumentsCompanyTable.vue?vue&type=script&lang=js"
export * from "./DocumentsCompanyTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCompanyTable.vue?vue&type=style&index=0&id=98a58b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a58b16",
  null
  
)

export default component.exports